/**
 * WaterWatch LiveMap Component
 * Displays river stations, alerts, and citizen reports on an interactive map
 * 
 * Dependencies: react-leaflet, leaflet
 * Install: npm install react-leaflet leaflet
 */

import React from 'react';
import WaterWatchMap from './WaterWatchMap';

const LiveMap = () => <WaterWatchMap />;

export default LiveMap;
